var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBilling(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iconBilling_svg__clip0_897_50)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.125 15H1.875a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5h14.25a1.5 1.5 0 011.5 1.5v9a1.5 1.5 0 01-1.5 1.5zm-15-7.125h15.75v-1.5H1.125v1.5zM16.875 4.5a.75.75 0 00-.75-.75H1.875a.75.75 0 00-.75.75v1.125h15.75V4.5zm0 4.125H1.125V13.5c0 .414.336.75.75.75h14.25a.75.75 0 00.75-.75V8.625zm-7.125 2.25h-1.5a.375.375 0 110-.75h1.5a.375.375 0 110 .75zm-3.375 0H3a.375.375 0 110-.75h3.375a.375.375 0 110 .75zM3 12h2.25a.375.375 0 110 .75H3A.375.375 0 113 12z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconBilling_svg__clip0_897_50"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBilling);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconBilling.85e79601.svg";
export { MemoForwardRef as ReactComponent };